import { FC } from 'react';
import { Skeleton } from 'antd';
import { useGetShareContent } from '@/common/hook/useShareContent';
import { useShareMetaTags } from '@/common/hook/useShareMetaTags';
import V2Empty from '@/common/components/Data/V2Empty';
import MallDecisionReport from '@/common/components/business/ExpandStore/ChanceDetailDrawer/MallDecisionReport';

const MallReportShare: FC = () => {
  const { shareId, shareParams, loading, error } = useGetShareContent();
  useShareMetaTags(shareParams?.shareTitle, shareParams?.shareDescription);
  if (loading) return <Skeleton active />;
  const id = Number(shareParams?.id);
  if (!shareId || error || !shareParams?.token || !Number.isSafeInteger(id) || id <= 0) {
    return <V2Empty type='fail' customTip='分享链接无效或已失效' />;
  }
  return <MallDecisionReport open shared chancePointId={id} shareParams={shareParams} />;
};

export default MallReportShare;
